const refreshToken = async () => {
  const request = new Request(
    `${process.env.REACT_APP_API_URL}/authentication/refresh`,
    {
      method: 'POST',
      credentials: 'include',
      headers: new Headers({ 'Content-Type': 'application/json' }),
    },
  );
  const response = await fetch(request);
  if (response.status < 200 || response.status >= 300) {
    throw new Error('Unauthorized');
  }
  const auth = await response.json();

  localStorage.setItem('auth', JSON.stringify(auth));
};

export const authenticatedFetch = async (
  input: RequestInfo | URL,
  options: RequestInit = {},
  iteration = 0,
): Promise<Response> => {
  const headers = new Headers(options.headers || {});

  if (!headers.has('Accept')) {
    headers.set('Accept', 'application/json');
  }

  if (!headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json; charset=UTF-8');
  }

  const authItem = localStorage.getItem('auth');
  if (authItem) {
    try {
      const auth = JSON.parse(authItem);
      if (auth?.token) {
        headers.set('Authorization', `Bearer ${auth.token}`);
      }
    } catch {
      localStorage.removeItem('auth');
    }
  }

  const response = await fetch(input, {
    ...options,
    headers,
    credentials: 'include',
  });

  if (response.status === 401) {
    let message: string | undefined;

    try {
      const body = await response.json();
      message = body?.message;
    } catch {
      message = undefined;
    }

    if (iteration === 0 && message === 'Token expired') {
      try {
        await refreshToken();
        return await authenticatedFetch(input, options, iteration + 1);
      } catch {
        localStorage.removeItem('auth');
        throw new Error('Unauthorized');
      }
    }

    localStorage.removeItem('auth');
    throw new Error('Unauthorized');
  }

  return response;
};
